/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Shop_Group_VariantsInputs */

const vi_shop_group_variants = /** @type {(inputs: Shop_Group_VariantsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Loại (SKU ERP) — ${i?.n} loại`)
};

/**

* @param {Shop_Group_VariantsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_variants = /** @type {((inputs: Shop_Group_VariantsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_VariantsInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_variants(inputs)
});